module.exports = __webpack_public_path__ + "static/media/9DESA10.e6461295.jpg";